import { observer } from "mobx-react-lite";
import { useTranslations } from "next-intl";

import { type ViewerNode } from "@/components/doc/right-sidebar/node-viewer/types";
import { setNodeType } from "@/components/doc/right-sidebar/node-viewer/utils";
import { Dropdown } from "@/components/sidebar/Dropdown";

type Props = {
  node: ViewerNode;
  ids?: Set<string>;
  trigger: React.ReactNode;
  className?: string;
};

export const NodeTypeSelector = observer(function NodeTypeSelector({
  node,
  ids,
  trigger,
  className,
}: Props) {
  const t = useTranslations("sidebar");

  const items = [
    {
      title: t("nodeProps.nodeType.constant"),
      active: node.type === "constant",
      onClick: () => {
        const nodesToChange = [...(ids?.values() ?? [])].map(
          (id) => node.doc.nodes.get(id)!,
        ) as ViewerNode[];
        setNodeType(nodesToChange ?? node, "constant");
      },
    },
    {
      title: t("nodeProps.nodeType.variable"),
      active: node.type === "variable",
      onClick: () => {
        const nodesToChange = [...(ids?.values() ?? [])].map(
          (id) => node.doc.nodes.get(id)!,
        ) as ViewerNode[];
        setNodeType(nodesToChange ?? node, "variable");
      },
    },
  ].filter((item) => !item.active);

  return <Dropdown items={items} className={className} toggleButtonComponent={trigger} />;
});
